const TOKEN_NAME = 'authToken'
const ROLE = 'role'
const PATH = 'path'
const ALREADY_EVALUATED = 'customPlaylistEvaluated'

const Storage = {
  role: {
    get: () => localStorage?.getItem(ROLE) || '',
    set: (role: string) => {
      localStorage?.setItem(ROLE, role)
    },
    clear: () => {
      localStorage?.removeItem(ROLE)
    },
  },
  token: {
    get: (): string => {
      return localStorage?.getItem(TOKEN_NAME) as string
    },
    set: (authToken: string) => {
      localStorage?.setItem(TOKEN_NAME, authToken)
    },
    remove: () => {
      localStorage?.removeItem(TOKEN_NAME)
    },
  },
  path: {
    get: (): string => {
      return localStorage?.getItem(PATH) as string
    },
    set: (path: string) => {
      localStorage?.setItem(PATH, path)
    },
    remove: () => {
      localStorage?.removeItem(PATH)
    },
  },
  customPlaylistEvaluation: {
    get: (): string => {
      return localStorage?.getItem(ALREADY_EVALUATED) as string
    },
    set: (value: string) => {
      localStorage?.setItem(ALREADY_EVALUATED, value)
    },
    remove: () => {
      localStorage?.removeItem(ALREADY_EVALUATED)
    },
  }
}

export default Storage
